import { graphql } from "@/graphql/codegen"
import "./salesOrderFragments"

graphql(`
  query GetCustomerOrderSalesOrders($input: SalesOrderListInput!) {
    salesOrder {
      list(input: $input) {
        __typename
        ... on SalesOrderListSuccess {
          salesOrders {
            ...CustomerOrderSalesOrderFields
          }
          pageInfo {
            ...PageInfoFields
          }
        }
        ... on SalesOrderListFailure {
          error {
            message
          }
        }
      }
    }
  }
`)

graphql(`
  query GetSalesOrderList($input: SalesOrderListInput!) {
    salesOrder {
      list(input: $input) {
        __typename
        ... on SalesOrderListSuccess {
          salesOrders {
            ...CustomerOrderSalesOrderFields
            promisedShipOn
          }
          pageInfo {
            ...PageInfoFields
          }
        }
        ... on SalesOrderListFailure {
          error {
            message
          }
        }
      }
    }
  }
`)

graphql(`
  query GetCustomerPurchaseOrderPricingTotals($input: CustomerPurchaseOrderPricingTotalsInput!) {
    salesOrder {
      calculateCustomerPurchaseOrderPricingTotals(input: $input) {
        __typename
        ... on CustomerPurchaseOrderPricingTotalsSuccess {
          total {
            pallets
            units
            quantity
            uomId
            effectiveDate
          }
          products {
            productId
            lines {
              pricingEffectiveDate
              price {
                pricePerUnit
                uomId
                isManual
              }
              converted {
                pricePerUnit
                pricePerUnitUomId
                quantity
              }
              opposite {
                quantity
                quantityUomId
              }
              total {
                price
              }
            }
            total {
              pallets
              units
              quantity
              uom {
                uomId
                amount
              }
            }
            converted {
              quantity
              uomId
            }
          }
        }
        ... on CustomerPurchaseOrderPricingTotalsFailure {
          error {
            message
          }
        }
      }
    }
  }
`)
